/** Mensagens de validação por campo, como retornadas pelo backend (`{data: {errors: {...}}}`). */
export interface ApiFieldErrors {
  [field: string]: string | string[]
}

export interface ApiErrorData {
  message?: string
  errors?: ApiFieldErrors
  /** Código de negócio que alguns handlers do backend acrescentam (ex.: `SncrNegocioException`). */
  codigo?: string
}

/**
 * Com `message` do backend, só ela aparece: é a frase que explica o erro ("Formulário sem empresa
 * não pode ser duplicado por esta rota"). Os erros por campo só entram quando não há `message`.
 */
export const buildErrorMessage = (errorData: ApiErrorData) => {
  const message = errorData.message?.trim()
  if (message) return `<p>${message}</p>`

  const errorDetails: string[] = []

  if (errorData.errors) {
    for (const key in errorData.errors) {
      const errorsArray = errorData.errors[key]

      if (Array.isArray(errorsArray) && errorsArray.length > 0) {
        errorDetails.push(`<div>${errorsArray.join('<br><br>')}</div>`)
      }
    }
  }

  return errorDetails.length > 0 ? errorDetails.join('<hr>') : '<p>Um erro ocorreu.</p>'
}
